var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Timer, Vector2i, VRect } from "js-vextensions";
import keycode from "keycode";
import { runInAction } from "mobx";
import { BaseComponentPlus } from "react-vextensions";
import { store } from "Store";
import { GetMapObject, GetMapObjectsInMap, GetSelectedMapObject } from "Store/firebase/mapObjects";
import { GetMapObjectFinalPositions } from "Store/firebase/mapObjects/$mapObject";
import * as THREE from "three";
import { ElementAcceptsTextInput, Observer } from "vwebapp-framework";
import { DistanceUnit } from "../../../Store/firebase/mapObjects/Components/@ShapeComp";
import { MapObjectUI } from "./MapObjectUI";
import { MapObjectUI_Overlay } from "./MapObjectUI_Overlay";
import { AddObject } from "./Tools/AddObject";
import { DrawShape } from "./Tools/DrawShape";
import { EditPoints } from "./Tools/EditPoints";
import { MoveObject } from "./Tools/MoveObject";
import { RedrawSegment } from "./Tools/RedrawSegment";
import { SelectObject } from "./Tools/SelectObject";
//import React3 from "react-three-renderer";
// temp, till react-three-renderer-fiber is ready
const React3 = (...props) => React.createElement("div", null);
const ToolClasses = [
    AddObject,
    MoveObject,
    DrawShape,
    RedrawSegment,
    SelectObject,
    EditPoints,
];
export function GetToolClassByName(name) {
    return ToolClasses.find(a => a.name == name);
}
export var currentMapTool;
export function SetCurrentMapTool(tool) {
    /*let toolType = GetToolClassByName(tool);
    currentMapTool = toolType ? new toolType(this) : null;*/
    currentMapTool = tool;
}
export const unzoomedViewSize_meters_height = 10;
const scrollKeys = ["a", "d", "s", "w", "q", "e"];
const keyScrollTimerInterval = 1000 / 30;
let MapScene = class MapScene extends BaseComponentPlus({}, { zoomLevel_override: null, addingObject_obj: null, viewCenter_override: null }) {
    constructor() {
        super(...arguments);
        this.cameraPosition = new THREE.Vector3(0, 0, 5);
        this.scrollKeysDown = {};
        this.OnKeyDown_Global = (e) => {
            const keyName = keycode.names[e.which];
            if (this.scrollKeysDown[keyName])
                return; // only trigger on depression action, not on key-repeat
            if (scrollKeys.Contains(keyName)) {
                this.scrollKeysDown[keyName] = true;
                if (!this.keyScrollTimer.IsRunning) {
                    this.keyScrollTimer.Start();
                }
            }
        };
        this.OnKeyUp_Global = (e) => {
            const keyName = keycode.names[e.which];
            if (scrollKeys.Contains(keyName)) {
                delete this.scrollKeysDown[keyName];
                if (this.scrollKeysDown.VKeys().length == 0) {
                    this.keyScrollTimer.Stop();
                    this.EndKeyScroll();
                }
            }
        };
        this.keyScrollTimer = new Timer(keyScrollTimerInterval, () => {
            //const zoomLevel = store.main.write.map.zoomLevel);
            //const viewCenter = store.main.write.map.viewCenter.As(Vector2i);
            const { zoomIn } = this.props;
            const scrollSpeed_keys = store.main.write.map.scrollSpeed_keys;
            const zoomSpeed_keys = store.main.write.map.zoomSpeed_keys;
            if (ElementAcceptsTextInput(document.activeElement))
                return;
            const scrollSpeed_keys_world = scrollSpeed_keys * this.PixelLengthInMeters();
            const xChangePerSecond = scrollSpeed_keys_world * (this.scrollKeysDown.a ? -1 : this.scrollKeysDown.d ? 1 : 0);
            const yChangePerSecond = scrollSpeed_keys_world * (this.scrollKeysDown.s ? -1 : this.scrollKeysDown.w ? 1 : 0);
            this.KeyScroll(new Vector2i(xChangePerSecond, yChangePerSecond).Times(keyScrollTimerInterval / 1000));
            const zoomSpeed_keys_fraction = zoomSpeed_keys / 100;
            if (this.scrollKeysDown.q) {
                zoomIn(1 / (1 + zoomSpeed_keys_fraction), new Vector2i(.5, .5));
            }
            else if (this.scrollKeysDown.e) {
                zoomIn(1 + zoomSpeed_keys_fraction, new Vector2i(.5, .5));
            }
        });
        this.mapObjectUIs = {};
        this.mapObjectUIs_overlays = {};
    }
    OnAnimate() { }
    /*ComponentWillMountOrReceiveProps(props_) {
        let props = this.props; props = props_; // use this sneaky assignment to get type-data for comp's props
        if (props.selectedTool != (currentMapTool || {} as any).constructor.name || (currentMapTool && currentMapTool.mapScene != this)) {
            let toolType = GetToolClassByName(props.selectedTool);
            currentMapTool = toolType ? new toolType(this) : null;
        }
    }*/
    /*ComponentWillMount() {
        if (currentMapTool && currentMapTool.MapScene != this) {
            SetCurrentMapTool(this.props.selectedTool);
        }
    }*/
    ComponentDidMount() {
        document.addEventListener("keydown", this.OnKeyDown_Global);
        document.addEventListener("keyup", this.OnKeyUp_Global);
    }
    ComponentWillUnmount() {
        this.keyScrollTimer.Stop();
        document.removeEventListener("keydown", this.OnKeyDown_Global);
        document.removeEventListener("keyup", this.OnKeyUp_Global);
    }
    KeyScroll(scrollChange) {
        const viewCenter = store.main.write.map.viewCenter.As(Vector2i);
        const { viewCenter_override } = this.state;
        this.SetState({ viewCenter_override: (viewCenter_override || viewCenter).Plus(scrollChange) });
    }
    EndKeyScroll() {
        const { viewCenter_override } = this.state;
        if (viewCenter_override == null)
            return;
        runInAction("MapUI.EndKeyScroll", () => store.main.write.map.viewCenter = viewCenter_override);
        this.SetState({ viewCenter_override: null });
    }
    ViewSize_Pixels(width = this.props.width, height = this.props.height) { return new Vector2i(width, height); }
    ViewSize_Meters(viewSize_pixels = this.ViewSize_Pixels(), pixelSizeInMeters = this.PixelLengthInMeters()) { return viewSize_pixels.Times(pixelSizeInMeters); }
    CanvasPosToCanvasY0BotPos(canvasPos, viewSize_pixels = this.ViewSize_Pixels()) { return canvasPos.NewY(oldY => viewSize_pixels.y - 1 - oldY); }
    CanvasY0BotPosToCanvasPos(canvasPos, viewSize_pixels = this.ViewSize_Pixels()) { return canvasPos.NewY(oldY => viewSize_pixels.y - 1 - oldY); }
    AspectRatio(width = this.props.width, height = this.props.height) { return width / height; }
    // size of area the camera will view (when unzoomed), in world units
    UnzoomedViewSize_Meters(aspectRatio = this.AspectRatio()) { return new Vector2i(aspectRatio * unzoomedViewSize_meters_height, unzoomedViewSize_meters_height); }
    ZoomedViewSize_Meters(unzoomedViewSize_meters = this.UnzoomedViewSize_Meters(), zoomLevel = store.main.write.map.zoomLevel) {
        return unzoomedViewSize_meters.DividedBy(zoomLevel);
    }
    PixelLengthInMeters(zoomedViewSize_meters = this.ZoomedViewSize_Meters(), viewSize_pixels = this.ViewSize_Pixels()) {
        //return new Vector2i(zoomedViewSize_meters.x / viewSize_pixels.x, zoomedViewSize_meters.y / viewSize_pixels.y);
        return zoomedViewSize_meters.x / viewSize_pixels.x;
    }
    MeterLengthInPixels(pixelSizeInMeters = this.PixelLengthInMeters()) {
        //return Vector2i.one.DividedBy(pixelSizeInMeters);
        return 1 / pixelSizeInMeters;
    }
    ConvertDistanceUnit(fromUnit, toUnit, value) {
        const value_meters = fromUnit == DistanceUnit.Meters ? value : value * this.PixelLengthInMeters();
        const value_toUnit = toUnit == DistanceUnit.Meters ? value_meters : value_meters * this.MeterLengthInPixels();
        return value_toUnit;
    }
    MousePos_Canvas(mousePos = g.mousePos, canvasPos = this.DOM.GetPageRect().Position) { return mousePos.Minus(canvasPos); }
    MousePos_CanvasY0Bot(mousePos_canvas = this.MousePos_Canvas()) { return this.CanvasPosToCanvasY0BotPos(mousePos_canvas); }
    //MousePos_World() { return CanvasPosToWorldPos(this.MousePos_Canvas, this.ViewSize_Pixels, this.camera); }
    MousePos_World(mousePos_canvas = this.MousePos_Canvas()) { return this.CanvasPosToWorldPos(mousePos_canvas); }
    get ZoomLevel_Live() {
        const zoomLevel = store.main.write.map.zoomLevel;
        return this.state.zoomLevel_override || zoomLevel;
    }
    get ViewCenter_Live() {
        const viewCenter = store.main.write.map.viewCenter.As(Vector2i);
        return this.state.viewCenter_override || viewCenter;
    }
    ViewCenterToViewBottomLeft(viewCenter) {
        return viewCenter.Minus(this.ViewSize_Meters().Times(.5));
    }
    // "canvas pos" means screen-pos distance (ie. diff, kept +) from bottom-left of viewport/canvas
    CanvasPosToWorldPos(canvasPos, useLiveOffset = false) {
        return this.CanvasY0BotPosToWorldPos(this.CanvasPosToCanvasY0BotPos(canvasPos), useLiveOffset);
    }
    CanvasY0BotPosToWorldPos(canvasPos, useLiveOffset = false) {
        const viewCenter = store.main.write.map.viewCenter.As(Vector2i);
        const viewBottomLeft = this.ViewCenterToViewBottomLeft((useLiveOffset && this.state.viewCenter_override) || viewCenter);
        return viewBottomLeft.Plus(canvasPos.Times(this.PixelLengthInMeters()));
    }
    WorldPosToCanvasY0BotPos(worldPos, useLiveOffset = false) {
        const viewCenter = store.main.write.map.viewCenter.As(Vector2i);
        const viewBottomLeft = this.ViewCenterToViewBottomLeft((useLiveOffset && this.state.viewCenter_override) || viewCenter);
        return worldPos.Minus(viewBottomLeft).DividedBy(this.PixelLengthInMeters());
    }
    WorldViewArea(viewCenter = this.ViewCenter_Live, viewSize_meters = this.ViewSize_Meters()) {
        const result = new VRect(0, 0, 0, 0);
        result.Center = viewCenter;
        result.Size = viewSize_meters;
        return result;
    }
    UpdateMapObjectUI(id, updateOverlay = true) {
        const objUI = this.mapObjectUIs[id];
        if (objUI) {
            objUI.Update();
        }
        const objUI_overlay = this.mapObjectUIs_overlays[id];
        if (objUI_overlay && updateOverlay) {
            objUI_overlay.Update();
        }
    }
    render() {
        const { book, width, height, zoomIn } = this.props;
        const mapObjects = GetMapObjectsInMap(book._key);
        const selectedTool = store.main.write.selectedTool;
        const rootObject = GetMapObject(book.rootMapObject);
        const mapObjectFinalPositions = GetMapObjectFinalPositions(mapObjects);
        // simple listeners (so map-scene rerenders when they change)
        const selectedObject = GetSelectedMapObject();
        const zoomLevel = this.ZoomLevel_Live;
        const viewCenter = this.ViewCenter_Live;
        const { addingObject_obj } = this.state;
        const c = {
            /*viewSize: viewSize,
            aspectRatio: aspectRatio,*/
            left: viewCenter.x - (this.ZoomedViewSize_Meters().x / 2),
            right: viewCenter.x + (this.ZoomedViewSize_Meters().x / 2),
            top: viewCenter.y + (this.ZoomedViewSize_Meters().y / 2),
            bottom: viewCenter.y - (this.ZoomedViewSize_Meters().y / 2),
            near: .1,
            far: 1000,
        };
        this.mapObjectUIs = {};
        this.mapObjectUIs_overlays = {};
        return (React.createElement("div", { style: { position: "relative", overflow: "hidden" }, onMouseDown: e => {
                if (currentMapTool && currentMapTool.Scene_OnMouseDown(e))
                    return;
                if (e.button == 1) {
                    //let uiPoint_y0Bot = new Vector2i(e.pageX - e.currentTarget.GetPageRect().x, e.pageY.Distance(e.currentTarget.GetPageRect().Bottom));
                    //this.scroll_startMousePos_world = ToVector2i(this.MousePos_World);
                    this.scroll_startMousePos_canvas = this.MousePos_Canvas();
                    this.scroll_startViewCenter = new Vector2i(viewCenter.x | 0, viewCenter.y | 0);
                }
            }, onMouseMove: e => {
                if (currentMapTool && currentMapTool.Scene_OnMouseMove(e))
                    return;
                if (this.scroll_startViewCenter) {
                    //Log("Scrolling to: " + this.Scroll_NewViewCenter);
                    //store.dispatch(new ACTScrollMap({scrollTo: this.Scroll_NewScrollOffset}))
                    this.SetState({ viewCenter_override: this.Scroll_NewViewCenter });
                }
            }, onMouseUp: e => {
                if (currentMapTool && currentMapTool.Scene_OnMouseUp(e))
                    return;
                if (e.button == 1) {
                    runInAction("MapUI.onMouseUp", () => store.main.write.map.viewCenter = this.Scroll_NewViewCenter);
                    this.scroll_startMousePos_canvas = null;
                    this.scroll_startViewCenter = null;
                    this.SetState({ viewCenter_override: null });
                }
            }, onWheel: e => {
                if (currentMapTool && currentMapTool.Scene_OnWheel(e))
                    return;
                var controlPoint_relative = this.MousePos_Canvas().DividedBy(this.ViewSize_Pixels());
                if (e.nativeEvent["wheelDelta"] > 0) {
                    zoomIn(1 + ((e.nativeEvent["wheelDelta"] / 120) * .1), controlPoint_relative);
                }
                else {
                    const zoomOutAmount = 1 + ((-e.nativeEvent["wheelDelta"] / 120) * .1);
                    zoomIn(1 / zoomOutAmount, controlPoint_relative);
                }
            } },
            React.createElement(React3, { mainCamera: "camera", width: width, height: height, antialias: true, onAnimate: this.OnAnimate },
                React.createElement("scene", null,
                    React.createElement("orthographicCamera", Object.assign({ ref: c => this.camera = c, name: "camera" /*fov={75} aspect={width / height}*/ }, c, { position: this.cameraPosition })),
                    mapObjects.map(obj => {
                        return React.createElement(MapObjectUI, { ref: c => this.mapObjectUIs[obj._key] = c, key: obj._key, obj: obj, mapScene: this, finalPos: mapObjectFinalPositions[obj._key], worldViewArea: this.WorldViewArea() });
                    }),
                    currentMapTool && currentMapTool.RenderInScene())),
            React.createElement("div", { id: "overlay", style: { position: "absolute", left: 0, top: 0, width, height } },
                mapObjects.map(obj => {
                    return React.createElement(MapObjectUI_Overlay, { ref: c => this.mapObjectUIs_overlays[obj._key] = c, key: obj._key, obj: obj, mapScene: this, finalPos: mapObjectFinalPositions[obj._key], worldViewArea: this.WorldViewArea() });
                }),
                currentMapTool && currentMapTool.RenderInSceneOverlay())));
    }
    get Scroll_NewViewCenter() {
        //let uiPoint_y0Bot = new Vector2i(e.pageX - e.currentTarget.GetPageRect().x, e.pageY.Distance(e.currentTarget.GetPageRect().Bottom));
        //let mouseMove_world = uiPoint_y0Bot.Minus(this.scroll_activeStartPos).Times(1 / zoomLevel);
        //let mouseMove_world = ToVector2i(this.MousePos_World).Minus(this.scroll_startMousePos_world);
        const mouseMove_canvas = this.MousePos_Canvas().Minus(this.scroll_startMousePos_canvas);
        const mouseMove_world = mouseMove_canvas.NewY(y => -y).Times(this.PixelLengthInMeters());
        const scrollTo = this.scroll_startViewCenter.Minus(mouseMove_world);
        return scrollTo;
    }
};
MapScene = __decorate([
    Observer
], MapScene);
export { MapScene };
/*function CanvasPosToWorldPos(canvasPos_px: Vector2i, canvasSize_px: Vector2i, camera: THREE.Camera, targetZ = 0) {
    /*let vector = new THREE.Vector3();
    vector.set((canvasPos_px.x / canvasSize_px.x) * 2 - 1, -(canvasPos_px.y / canvasSize_px.y) * 2 + 1, .5);
    vector.unproject(camera);

    let dir = vector.sub(camera.position).normalize();
    let distance = (targetZ - camera.position.z) / dir.z;

    let result = camera.position.clone().add(dir.multiplyScalar(distance));
    return result;*/
/*var planeZ = new THREE.Plane(new THREE.Vector3(0, 0, 1), 0);
var posInCamView = new THREE.Vector3((canvasPos_px.x / canvasSize_px.x) * 2 - 1, -(canvasPos_px.y / canvasSize_px.y) * 2 + 1, 0.5);

var raycaster = new THREE.Raycaster();
raycaster.setFromCamera(posInCamView, camera); // update the picking ray with the camera and mouse position

var result = raycaster.ray.intersectPlane(planeZ);
//console.log("x: " + pos.x + ", y: " + pos.y);matrix.multiplyMatrices( camera.matrixWorld, matrix.getInverse( camera.projectionMatrix ) );
        return this.applyMatrix4( matrix );
return result;*#/

let vector = new THREE.Vector3();
vector.set((canvasPos_px.x / canvasSize_px.x) * 2 - 1, -(canvasPos_px.y / canvasSize_px.y) * 2 + 1, 0);
vector.unproject(camera);
return vector;
}*/ 
